module.exports = __webpack_public_path__ + "img/sad-logo-default.d5725e56.png";